import './form_label_view.js.coffee'

class Monitoring.Views.CreateLabelView extends Monitoring.Views.FormLabelView

  events: =>
    return _.extend({}, Monitoring.Views.FormLabelView.prototype.events, {
      'keypress #label-name': 'onKeypress'
    })

  initialize: (@options = {}) ->
    super(@options)
    @formName = 'Create new'

  onKeypress: (event) =>
    if event.which is 13 #Enter key
      @keywordView.addKeyword(@$el.find('#label-name').val().trim())

  _getKeywords: ->
    return []
